const MEHDI_QUICK_PRODUCT_CACHE_LIMIT = 12;
const MEHDI_QUICK_COLLECTION_CACHE_LIMIT = 4;
const MEHDI_QUICK_PREFETCH_DELAY = 60;

const mehdiQuickProductCache = new Map();
const mehdiQuickProductRequests = new Map();
const mehdiQuickCollectionCache = new Map();
const mehdiQuickCollectionRequests = new Map();

let mehdiQuickActiveController = null;
let mehdiQuickRenderToken = 0;
let mehdiQuickPrefetchTimer = null;

if (typeof document !== 'undefined' && document.addEventListener) {
  document.addEventListener('click', function (e) {
    if (window.innerWidth <= 749) return;

    const target = getEventElement(e);
    if (!target) return;

    if (target.closest('#mehdiPanel.active #mehdiContent slideshow-controls, #mehdiPanel.active #mehdiContent slideshow-arrows')) {
      pauseMehdiQuickVideos();
    }

    if (target.id === 'mehdiOverlay') {
      closeMehdiQuick();
      return;
    }

    const link = target.closest('a[href*="/products/"]');
    if (!link) return;

    if (!link.closest('.card-product, .product-card, .grid__item, product-card')) return;

    if (!canOpenMehdiQuick()) return;

    e.preventDefault();
    e.stopPropagation();

    const productUrl = link.href;
    const currentCollection = getCurrentCollectionContext();

    fetchAndRenderProduct(productUrl, currentCollection);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (closeActiveMehdiStoreRequest()) return;
      closeMehdiQuick();
    }
  });

  document.addEventListener('slideshow:select', handleMehdiQuickMediaChange);

  document.addEventListener('pointerover', function (e) {
    if (window.innerWidth <= 749) return;

    const target = getEventElement(e);
    if (!target) return;

    const link = getQuickProductLink(target);
    if (!link || !canOpenMehdiQuick()) return;
    if (e.relatedTarget instanceof Node && link.contains(e.relatedTarget)) return;

    clearTimeout(mehdiQuickPrefetchTimer);

    mehdiQuickPrefetchTimer = window.setTimeout(function () {
      prefetchMehdiQuickProduct(link.href);
    }, MEHDI_QUICK_PREFETCH_DELAY);
  }, true);

  document.addEventListener('pointerout', function (e) {
    const target = getEventElement(e);
    if (!target) return;

    const link = getQuickProductLink(target);
    if (!link) return;
    if (e.relatedTarget instanceof Node && link.contains(e.relatedTarget)) return;

    clearTimeout(mehdiQuickPrefetchTimer);
  }, true);

  document.addEventListener('focusin', function (e) {
    if (window.innerWidth <= 749) return;

    const target = getEventElement(e);
    if (!target) return;

    const link = getQuickProductLink(target);
    if (!link || !canOpenMehdiQuick()) return;

    prefetchMehdiQuickProduct(link.href);
  });
}

function fetchAndRenderProduct(productUrl, currentCollection = null) {
  const mehdiContent = document.getElementById('mehdiContent');
  const mehdiPanel = document.getElementById('mehdiPanel');
  const mehdiOverlay = document.getElementById('mehdiOverlay');
  const currentProductHandle = getProductHandleFromUrl(productUrl);
  const productFetchUrl = getFetchUrl(productUrl);
  const renderToken = ++mehdiQuickRenderToken;

  if (!mehdiContent || !mehdiPanel || !mehdiOverlay) {
    console.log('Quick view container bulunamadı');
    return false;
  }

  pauseMehdiQuickVideos();

  mehdiPanel.classList.add('active');
  mehdiOverlay.classList.add('active');

  mehdiContent.innerHTML = getMehdiLoaderHtml();

  if (mehdiQuickActiveController) {
    mehdiQuickActiveController.abort();
  }

  mehdiQuickActiveController = typeof AbortController !== 'undefined'
    ? new AbortController()
    : null;

  fetchMehdiQuickProductHtml(
    productFetchUrl,
    mehdiQuickActiveController ? mehdiQuickActiveController.signal : null
  )
    .then(function (html) {
      if (renderToken !== mehdiQuickRenderToken) return;

      const temp = document.createElement('div');
      temp.innerHTML = html;

      const mainContent = temp.querySelector('#MainContent');

      if (!mainContent) {
        mehdiContent.innerHTML = `
          <div style="padding:40px;">
            Ürün içeriği bulunamadı.
          </div>
        `;
        return;
      }

      mehdiContent.innerHTML = mainContent.innerHTML;

      removeExistingRecommendations(mehdiContent);
      optimizeMehdiQuickImages(mehdiContent);

      if (currentCollection && currentCollection.handle) {
        scheduleMehdiQuickIdleTask(function () {
          if (renderToken !== mehdiQuickRenderToken) return;

          loadCollectionRecommendations({
            collectionHandle: currentCollection.handle,
            collectionUrl: currentCollection.url,
            currentProductHandle: currentProductHandle,
            mountEl: mehdiContent,
            renderToken: renderToken
          });
        });
      }

      runMiniSetScripts(mehdiContent);
      initMehdiProductStoreRequests(mehdiContent);
      bindInnerQuickLinks();
    })
    .catch(function (err) {
      if (err && err.name === 'AbortError') return;
      if (renderToken !== mehdiQuickRenderToken) return;

      console.log('Quick view yüklenemedi:', err);

      mehdiContent.innerHTML = `
        <div style="padding:40px;">
          Ürün yüklenemedi.
        </div>
      `;
    });

  return true;
}

function getQuickProductLink(target) {
  const link = target.closest('a[href*="/products/"]');
  if (!link) return null;

  if (!link.closest('.card-product, .product-card, .grid__item, product-card')) {
    return null;
  }

  return link;
}

function prefetchMehdiQuickProduct(productUrl) {
  const productFetchUrl = getFetchUrl(productUrl);

  if (
    !productFetchUrl ||
    mehdiQuickProductCache.has(productFetchUrl) ||
    mehdiQuickProductRequests.has(productFetchUrl)
  ) {
    return;
  }

  fetchMehdiQuickProductHtml(productFetchUrl, null).catch(function () {
    // Ön yükleme başarısız olursa tıklama anında normal istek yeniden denenir.
  });
}

function fetchMehdiQuickProductHtml(productFetchUrl, signal) {
  if (mehdiQuickProductCache.has(productFetchUrl)) {
    const cachedHtml = mehdiQuickProductCache.get(productFetchUrl);

    touchMehdiQuickCache(
      mehdiQuickProductCache,
      productFetchUrl,
      cachedHtml,
      MEHDI_QUICK_PRODUCT_CACHE_LIMIT
    );

    return Promise.resolve(cachedHtml);
  }

  if (mehdiQuickProductRequests.has(productFetchUrl)) {
    return mehdiQuickProductRequests.get(productFetchUrl);
  }

  const fetchOptions = {
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  };

  if (signal) {
    fetchOptions.signal = signal;
  }

  const request = fetch(productFetchUrl, fetchOptions)
    .then(function (res) {
      if (!res.ok) {
        throw new Error('Ürün isteği başarısız: ' + res.status);
      }

      return res.text();
    })
    .then(function (html) {
      touchMehdiQuickCache(
        mehdiQuickProductCache,
        productFetchUrl,
        html,
        MEHDI_QUICK_PRODUCT_CACHE_LIMIT
      );

      return html;
    })
    .finally(function () {
      mehdiQuickProductRequests.delete(productFetchUrl);
    });

  mehdiQuickProductRequests.set(productFetchUrl, request);

  return request;
}

function touchMehdiQuickCache(cache, key, value, limit) {
  if (cache.has(key)) {
    cache.delete(key);
  }

  cache.set(key, value);

  while (cache.size > limit) {
    const oldestKey = cache.keys().next().value;
    cache.delete(oldestKey);
  }
}

function optimizeMehdiQuickImages(root) {
  if (!root) return;

  const images = root.querySelectorAll('img');

  images.forEach(function (image, index) {
    image.decoding = 'async';

    if (index === 0) {
      image.loading = 'eager';
      image.fetchPriority = 'high';
      return;
    }

    image.loading = 'lazy';
    image.fetchPriority = 'low';
  });
}

function scheduleMehdiQuickIdleTask(callback) {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(callback, { timeout: 1200 });
    return;
  }

  window.setTimeout(callback, 450);
}

function getMehdiLoaderHtml() {
  return `
    <div style="
      width:100%;
      min-height:100vh;
      display:flex;
      flex-direction:column;
      align-items:center;
      justify-content:center;
      background:#fff;
      gap:18px;
    ">
      <svg width="58" height="58" viewBox="0 0 58 58" xmlns="http://www.w3.org/2000/svg">
        <g>
          <circle
            cx="29"
            cy="29"
            r="23"
            stroke="rgba(21,70,52,0.16)"
            stroke-width="5"
            fill="none"
          ></circle>

          <circle
            cx="29"
            cy="29"
            r="23"
            stroke="#154634"
            stroke-width="5"
            fill="none"
            stroke-linecap="round"
            stroke-dasharray="36 120"
          ></circle>

          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 29 29"
            to="360 29 29"
            dur="0.8s"
            repeatCount="indefinite"
          />
        </g>
      </svg>

      <div style="
        font-size:14px;
        color:#154634;
        letter-spacing:.3px;
        font-family:inherit;
      ">
        Ürün yükleniyor...
      </div>
    </div>
  `;
}

function runMiniSetScripts(root) {
  if (!root) return;

  root.querySelectorAll('script').forEach(function (script) {
    if (!script.textContent || !script.textContent.includes('data-mini-set-form')) return;

    const executableScript = document.createElement('script');
    executableScript.textContent = script.textContent;
    if (!document.body) return;

    document.body.appendChild(executableScript);
    executableScript.remove();
  });
}

function closeMehdiQuick() {
  const mehdiPanel = document.getElementById('mehdiPanel');
  const mehdiOverlay = document.getElementById('mehdiOverlay');

  pauseMehdiQuickVideos();
  clearTimeout(mehdiQuickPrefetchTimer);
  mehdiQuickRenderToken += 1;

  if (mehdiQuickActiveController) {
    mehdiQuickActiveController.abort();
    mehdiQuickActiveController = null;
  }

  if (mehdiPanel) {
    mehdiPanel.classList.remove('active');
  }

  if (mehdiOverlay) {
    mehdiOverlay.classList.remove('active');
  }

  closeActiveMehdiStoreRequest();
}

const MEHDI_PSTORE_FALLBACK_DATA = {
    "Antalya": [
      { name: "Storks Exclusive Alanya", address: "Storks Akdeniz Park Alanya, Mahmutlar Mahallesi 130. Sokak Akdeniz Park AVM No:3 İç Kapı No:22, Alanya, Antalya, Türkiye", phone: "+90 (532) 636 66 96", hours: "Pzt-Cts 10:00 - 22:00, Pazar 10:00 - 22:00", category: "Mağaza" },
      { name: "Moda Kuyumculuk", address: "Kızlar Pınarı Mahallesi Zamanoğlu Caddesi No:58-1/A, Alanya, Antalya, Türkiye", phone: "+90 (242) 522 59 62", category: "Satış Noktası" },
      { name: "Oscar Jewellery", address: "Liman Caddesi No:102, Manavgat, Antalya, Türkiye", phone: "+90 (242) 753 30 64", category: "Satış Noktası" },
      { name: "Öztürk Kuyumculuk (Lara Şubesi)", address: "Şirinyalı Mahallesi İsmet Gökşen Caddesi No:128A, Muratpaşa, Antalya, Türkiye", phone: "+90 (242) 503 55 55", category: "Satış Noktası" },
      { name: "Öztürkler Kuyumculuk", address: "Tahılpazarı Mahallesi Şarampol Caddesi No:79, Muratpaşa, Antalya, Türkiye", phone: "+90 (242) 242 27 27", category: "Satış Noktası" },
      { name: "Sarıcalar Kuyumculuk", address: "Gökyazı Mahallesi Andrey Karlov Caddesi No:2/B, Demre, Antalya, Türkiye", phone: "+90 (242) 871 66 11 - +90 (533) 719 45 46", category: "Satış Noktası" },
      { name: "Töngüşlü Kuyumculuk", address: "Merkez Mahallesi Çarşı İçi Caddesi No:7, Kumluca, Antalya, Türkiye", phone: "+90 (242) 887 54 15", category: "Satış Noktası" },
      { name: "Excellent Kuyumculuk/Papillon Aysha Hotel", address: "Papillon Aysha Hotel, İleribaşı Mevkii, Merkez, Belek Turizm Yolu, 07500 Serik, Antalya, Türkiye", phone: "+90 (242)710 12 00", category: "Satış Noktası" },
      { name: "Excellent Kuyumculuk/Papillon Zeugma Relaxury", address: "Papillon Zeugma Relaxury, Belek Turizm Merkezi İleribasi Mevkii, Belek, 07500 Serik, Antalya, Türkiye", phone: "+90 (242)710 10 00", category: "Satış Noktası" },
      { name: "Excellent Kuyumculuk/Papillon Belvil Hotel", address: "Papillon Belvil Hotel, Taşlıburun Mevkii Belek Turizm Merkezi, 07500 Serik, Antalya, Türkiye", phone: "+90 (242)710 09 00", category: "Satış Noktası" },
      { name: "Kybele Jellery/Limak Atlantis", address: "Limak Atlantis Deluxe Hotel & Resort, Belek, 20. Sok No:10, 07500 Serik, Antalya, Türkiye", phone: "+90 (542)839 69 76", category: "Satış Noktası" },
      { name: "Kybele Jellery/Limak Arcadia", address: "Limak Arcadia Sport Resort Hotel, Belek, İskele Cd. No:12, 07552 Serik, Antalya, Türkiye", phone: "+90 (542)839 69 76", category: "Satış Noktası" },
    ],
    "Balıkesir": [
      { name: "Storks Balıkesir", address: "Karaoğlan Mahallesi, Zağnos Paşa Caddesi, No:15, Karesi, Balıkesir, Türkiye", phone: "+90 (532) 332 93 10", hours: "Pzt-Cuma 09:00 - 19:00, Cts-Paz Kapalı", category: "Mağaza" },
      { name: "Mavi Köşe Kuyumculuk", address: "Şehit Süleyman Bey Caddesi No:22, Bandırma, Balıkesir, Türkiye", phone: "+90 (266) 715 43 53", category: "Satış Noktası" },
      { name: "Sezersan Kuyumculuk", address: "Yukarı Çarşı Caddesi No:14/B, Edremit, Balıkesir, Türkiye", phone: "+90 (266) 373 10 49", category: "Satış Noktası" }
    ],
    "İstanbul": [
      { name: "Storks Bahçeşehir", address: "Bahçeşehir F Çarşısı No:21 Bahçeşehir, Başakşehir, İstanbul, Türkiye", phone: "+90 (507) 829 18 74", hours: "Pzt-Cts 10:00 - 19:00, Pazar Kapalı", category: "Mağaza" },
      { name: "Storks Beylikdüzü", address: "Adnan Kahveci Mahallesi, Anadolu Caddesi, Dora Park2 A Blok, Beylikdüzü, İstanbul, Türkiye", phone: "+90 (532) 660 19 20", hours: "Pzt-Cts 09:00 - 19:00, Pazar Kapalı", category: "Mağaza" },
      { name: "Storks Beyoğlu", address: "Şehit Muhtar Mahallesi İstiklal Caddesi No:22, Beyoğlu, İstanbul, Türkiye", phone: "+90 (212) 245 45 63", category: "Mağaza" },
      { name: "Storks Capacity", address: "Storks Capacity AVM, Ataköy 1. Kısım Mahallesi, Fişekhane Caddesi No:7, Bakırköy, İstanbul, Türkiye", phone: "+90 (552) 756 83 96", hours: "Pzt-Cts 10:00 - 22:00, Pazar 10:00 - 22:00", category: "Mağaza" },
      { name: "Storks Emaar Square", address: "Emaar Square Alışveriş Merkezi Ünalan Mahallesi Libadiye Caddesi Kat: -1, Üsküdar, İstanbul, Türkiye", phone: "+90 (216) 510 80 26", hours: "Pzt-Cts 10:00 - 22:00, Pazar 10:00 - 22:00", category: "Mağaza" },
      { name: "Storks Merkez Mağaza", address: "Kazlıçeşme Mahallesi,Kennedy Caddesi No:52/I Blok Büyükyalı-Fişekhane, Zeytinburnu, İstanbul, Türkiye", phone: "+90 (212) 526 10 10", category: "Mağaza" },
      { name: "Storks Exclusive Fişekhane", address: "Fişekhane Avm içi, Kazlıçeşme, Kennedy Cad. No: 52FG, 34020 Zeytinburnu, İstanbul", phone: "+90 (544) 342 70 68", category: "Mağaza" },
      { name: "Güven-Nur Kuyumculuk", address: "Atatürk Caddesi No:11-A, Alibeyköy, İstanbul, Türkiye", phone: "+90 (212) 625 15 38", category: "Satış Noktası" },
      { name: "Yenigün Kuyumculuk", address: "Fevzipaşa Caddesi No:52/A, Fatih, İstanbul, Türkiye", phone: "+90 (212) 533 50 85", category: "Satış Noktası" },
      { name: "Storks Özdilekpark AVM", address: "Özdilek Park Alışveriş Merkezi Esentepe Mahallesi Büyükdere Caddesi Zemin Kat, Levent, İstanbul, Türkiye", phone: "+90 (212) 264 17 30", hours: "Pzt-Cts 10:00 - 22:00, Pazar Kapalı", category: "Mağaza" },
      { name: "Storks Capitol AVM", address: "Capitol AVM içi, Altunizade, Mahir İz Cd., 34662 Üsküdar, İstanbul, Türkiye", phone: "+90 (216)651 32 83", hours: "Pzt-Pzr 10:00 - 22:00", category: "Mağaza" },
    ],
    "İzmir": [
      { name: "Storks MaviBahçe AVM", address: "Storks MaviBahçe AVM, Mavişehir Mahallesi Aziz Nesin Bulvarı, Karşıyaka, İzmir, Türkiye", phone: "+90 (232) 324 12 51", hours: "Pzt-Cts 10:00 - 22:00, Pazar 10:00 - 22:00", category: "Mağaza" },
      { name: "Storks Urla", address: "Yelaltı Mahallesi Mustafa Kemal Paşa Caddesi No:3, Urla, İzmir, Türkiye", phone: "+90 (538) 973 49 00", hours: "Pzt-Cts 09:30 - 19:00, Pazar Kapalı", category: "Mağaza" },
      { name: "Mustafa Koç Kuyumculuk", address: "16 Eylül Mahallesi 2001 Sokak No:93/B, Çeşme, İzmir, Türkiye", phone: "+90 (232) 712 71 17", hours: "Pzt-Cts 10:00 - 18:00, Pazar Kapalı ", category: "Mağaza" },
      { name: "Naz Afrodit Kuyumculuk", address: "Hacı İsa Mahallesi Bülent Baratalı Bulvarı No:45/A, Urla, İzmir, Türkiye", phone: "+90 (232) 754 46 46", hours: "Pzt-Cts 08:00 - 20:00, Pazar Kapalı", category: "Mağaza" },
      { name: "Sadık Kuyumculuk", address: "Atatürk Caddesi No:20/15, Tire, İzmir, Türkiye", phone: "+90 (232) 500 02 04", hours: "Pzt-Cts 09:00 - 19:00, Pazar Kapalı", category: "Mağaza" },
      { name: "Akçay Kuyumculuk (Dikili)", address: "Adnan Menderes Caddesi No:28/A, Dikili, İzmir, Türkiye", phone: "+90 (232) 671 46 64", category: "Satış Noktası" },
      { name: "Akçay Kuyumculuk (Bergama)", address: "Barbaros Mahallesi Bankalar Caddesi No:1, Bergama, İzmir, Türkiye", phone: "+90 (232) 632 41 93", category: "Satış Noktası" },
      { name: "Erhan Kuyumculuk (Bayraklı)", address: "1643 Sokak No:47/A Sevgiyolu, Bayraklı, İzmir, Türkiye", phone: "+90 (232) 345 12 05", category: "Satış Noktası" },
      { name: "Erhan Kuyumculuk (Bornova)", address: "Ergene Mahallesi Mustafa Kemal Caddesi No:10/A, Bornova, İzmir, Türkiye", phone: "+90 (232) 345 12 05", category: "Satış Noktası" }
    ],
    "Kastamonu": [
      { name: "Storks Kastamonu", address: "Barutçuoğlu AVM Cebrail Mahallesi Yalçın Caddesi Kat:1, Merkez, Kastamonu, Türkiye", phone: "+90 (366) 212 95 00", hours: "Pzt-Cts 07:00 - 21:00, Pazar Kapalı", category: "Mağaza" },
      { name: "Pattabanoğlu Kuyumculuk", address: "Hepkebirler Mahallesi Belediye Caddesi, Merkez, Kastamonu, Türkiye", phone: "+90 (366) 214 89 08", category: "Satış Noktası" }
    ],
    "Isparta": [
      { name: "Storks Isparta", address: "Pirimehmet Mahallesi 1756.Sokak No:1/C, Merkez, Isparta, Türkiye", phone: "+90 246 232 63 73", hours: "Pzt-Cts 08:30 - 20:00, Pazar 08:30 - 20:00", category: "Mağaza" }
    ],
    "Niğde": [
      { name: "Storks Niğde", address: "İstasyon Caddesi No:10/10, Merkez, Niğde, Türkiye", phone: "+90 (388) 232 43 42", hours: "Pzt-Cts 10:00 - 19:00, Pazar Kapalı", category: "Mağaza" },
      { name: "Özalp Kuyumculuk", address: "Ahipaşa Mahallesi İstasyon Caddesi No:10/A, Merkez, Niğde, Türkiye", phone: "+90 (388) 232 43 42", category: "Satış Noktası" }
    ],
    "Ordu": [
      { name: "Storks Ordu", address: "Düz Mahallesi Fatih Caddesi No:14, Altınordu, Ordu, Türkiye", phone: "+90 (452) 222 92 92", hours: "Pzt-Cts 09:00 - 19:00, Pazar Kapalı", category: "Mağaza" },
      { name: "Hep Kuyumculuk", address: "Mustafakemalpaşa Mahallesi Sakarya Caddesi No:28/B, Fatsa, Ordu, Türkiye", phone: "+90 (452) 423 62 80", category: "Satış Noktası" }
    ],
    "Rize": [
      { name: "Storks Şimal AVM", address: "Rize Şimal AVM Müftü Mahallesi Atatürk Caddesi No:548, Merkez, Rize, Türkiye", phone: "+90 (464) 502 44 55", hours: "Pzt-Cts 10:00 - 22:00, Pazar 10:00 - 22:00", category: "Mağaza" },
      { name: "Altınköşe Kuyumculuk", address: "Çarşı Mahallesi Atatürk Caddesi No:370, Merkez, Rize, Türkiye", phone: "+90 (464) 214 07 07", category: "Satış Noktası" },
      { name: "Zümrüt Kuyumculuk", address: "Atatürk Caddesi No:197, Ardeşen, Rize, Türkiye", phone: "+90 (464) 715 45 34", category: "Satış Noktası" }
    ],
    "Sakarya": [
      { name: "Storks Sakarya Mercan", address: "Cumhuriyet Mahallesi Çark Caddesi No:12A, Adapazarı, Sakarya, Türkiye", phone: "+90 (533) 055 54 54", hours: "Pzt-Cts 09:00 - 21:00, Pazar Kapalı", category: "Mağaza" }
    ],
    "Tekirdağ": [
      { name: "Storks Tekirdağ", address: "Atatürk Mahallesi Hürriyet Caddesi No:23/24, Kapaklı, Tekirdağ, Türkiye", phone: "+90 (282) 717 85 88", hours: "Pzt-Cts 09:00 - 19:00, Pazar Kapalı", category: "Mağaza" },
      { name: "Sıla Kuyumculuk", address: "Gazi Osman Paşa Mahallesi 1. Cadde No:35, Çerkezköy, Tekirdağ, Türkiye", phone: "+90 (282) 726 93 59", category: "Satış Noktası" },
      { name: "Sultan Kuyumculuk", address: "Atatürk Caddesi No:21/B, Şarköy, Tekirdağ, Türkiye", phone: "+90 (282) 518 12 81", category: "Satış Noktası" }
    ],
    "Trabzon": [
      { name: "Storks Trabzon Forum AVM", address: "Trabzon Forum AVM Ortahisar Mahallesi Devlet Sahil Yolu Caddesi Zemin Kat, Trabzon, Türkiye", phone: "+90 (462) 330 00 93", hours: "Pzt-Cts 10:00 - 22:00, Pazar Kapalı", category: "Mağaza" },
      { name: "Turan Kardeşler Kuyumculuk", address: "Kunduracılar Caddesi Kuyumcular Çarşısı No:107/1, Merkez, Trabzon, Türkiye", phone: "+90 (530) 592 92 87", category: "Satış Noktası" }
    ],
    "Adana": [
      { name: "Geçioğlu Kuyumculuk", address: "Kuruköprü Mahallesi 6.Sokak No:1, Seyhan, Adana, Türkiye", phone: "+90 (322) 363 03 01", category: "Satış Noktası" },
      { name: "Navet Kuyumculuk", address: "Reşatbey Mahallesi Atatürk Caddesi No:32/19 Yeni Kuyu, Seyhan, Adana, Türkiye", phone: "+90 (532) 515 05 86 , 0533 571 48 08", category: "Satış Noktası" }
    ],
    "Aksaray": [
      { name: "Koray Mücevherat", address: "4 Nolu Hükümet Caddesi No:17, Merkez, Aksaray, Türkiye", phone: "+90 (382) 213 66 07", category: "Satış Noktası" }
    ],
    "Amasya": [
      { name: "Fazilet Kuyumculuk", address: "Kocacık Çarşısı İğneci Baba Sokak No:30/E, Merkez, Amasya, Türkiye", phone: "+90 (358) 218 26 51", category: "Satış Noktası" }
    ],
    "Ankara": [
      { name: "Storks Cepa AVM", address: "Cepa AVM Mustafa Kemal Mahallesi 2123.Sokak Zemin Kat No:41, Çankaya, Ankara, Türkiye", phone: "+90 (312) 219 72 95 & +90 (542) 486 93 83", category: "Satış Noktası" },
      { name: "Safir Mücevherat", address: "Ahmet Taner Kışlalı Mahallesi Muciburrahman Bulvarı No:94, Çayyolu, Ankara, Türkiye", phone: "+90 (312) 240 10 30", category: "Satış Noktası" },
      { name: "Paşaoğlu Kuyumculuk", address: "Belediye İş Hanı No:20/63, Beypazarı, Ankara, Türkiye", phone: "0 (312) 763 16 26", category: "Satış Noktası" }
    ],
    "Aydın": [
      { name: "Tufan Kuyumculuk", address: "Batı Gazi Bulvarı No:13/B, Merkez, Aydın, Türkiye", phone: "+90 (256) 213 03 89", category: "Satış Noktası" }
    ],
    "Bartın": [
      { name: "Borsa Kuyumculuk", address: "Kırtepe Mahallesi Hükümet Caddesi No:37, Merkez, Bartın, Türkiye", phone: "+90 (378) 228 62 88", category: "Satış Noktası" }
    ],
    "Çanakkale": [
      { name: "Paşa Kuyumculuk", address: "Kemalpaşa Mahallesi Çarşı Caddesi No:145, Merkez, Çanakkale, Türkiye", phone: "+90 (286) 212 63 66", category: "Satış Noktası" }
    ],
    "Çankırı": [
      { name: "Alabay Kuyumculuk", address: "Cumhuriyet Mahallesi Necip Fazıl Kısakürek Caddesi Meydan AVM, Merkez, Çankırı, Türkiye", phone: "+90 (376) 212 40 20", category: "Satış Noktası" }
    ],
    "Edirne": [
      { name: "Hudut Kuyumculuk", address: "Mithat Paşa Mahallesi Saraçlar Caddesi No:48, Merkez, Edirne, Türkiye", phone: "+90 (284) 225 19 72", category: "Satış Noktası" }
    ],
    "Elazığ": [
      { name: "Karakoçan Kuyumculuk", address: "İzzetpaşa Camii Pasajı B Kapı No:66, Merkez, Elazığ, Türkiye", phone: "+90 (424) 233 00 03", category: "Satış Noktası" }
    ],
    "Giresun": [
      { name: "Rehber Kuyumculuk", address: "Şeyh Keramettin Mahallesi Cemal Gürsel Caddesi No:1/E, Merkez, Giresun, Türkiye", phone: "+90 (454) 216 81 51", category: "Satış Noktası" }
    ],
    "Kahramanmaraş": [
      { name: "Zabun Kuyumculuk", address: "Kurtuluş Mahallesi Belediye Çarşısı No:54/C, Merkez, Kahramanmaraş, Türkiye", phone: "+90 (344) 221 55 39", category: "Satış Noktası" }
    ],

    "Kayseri": [
      { name: "Öztürk Kuyumculuk", address: "Kazancılar Çarşısı No:2/A, Melikgazi, Kayseri, Türkiye", phone: "+90 (352) 222 39 99", category: "Satış Noktası" }
    ],
    "Kırklareli": [
      { name: "Kanber Kuyumculuk", address: "Karakaş Mahallesi Zincirlikuyu Caddesi No:9/1, Kırklareli, Türkiye", phone: "+90 (288) 502 22 44", category: "Satış Noktası" }
    ],
    "Konya": [
      { name: "Storks Exclusive Konya", address: "Mussalla Bağları Mahallesi Kule Caddesi Kulesite AVM No:8 Zemin Kat, Selçuklu, Konya, Türkiye", phone: "+90 (533) 919 00 82", hours: "Pzt-Cts 10:00 - 22:00, Pazar 10:00 - 22:00", category: "Mağaza" },
      { name: "Karacaoğlu Kuyumculuk", address: "Mussalla Bağları Mahallesi Kule Caddesi Kulesite AVM No:8, Selçuklu, Konya, Türkiye", phone: "+90 (332) 236 36 77", category: "Satış Noktası" },
      { name: "Mendi Kuyumculuk", address: "Teyfikiye Caddesi Aşık Şem i Sokak No:4, Meram, Konya, Türkiye", phone: "0 (332) 351 04 41", category: "Satış Noktası" }
    ],
    "Muğla": [
      { name: "Glory Jewellery", address: "Grand Yazıcı Marmaris Place Otel İçmeler Mahallesi Atatürk Caddesi No:62, Marmaris, Muğla, Türkiye", phone: "+90 (252) 455 26 95", category: "Satış Noktası" },
      { name: "Kırkan Kuyumculuk", address: "Cumhuriyet Caddesi No:80, Milas, Muğla, Türkiye", phone: "+90 (252) 512 42 50", category: "Satış Noktası" },
      { name: "Tufanlar Kuyumculuk", address: "Batı Gazi Bulvarı No:13/B, Fethiye, Muğla, Türkiye", phone: "+90 (252) 614 10 34", category: "Satış Noktası" }
    ],
    "Tokat": [
      { name: "Safir Kuyumculuk", address: "Gazi Osman Paşa Bulvarı No:144/A, Merkez, Tokat, Türkiye", phone: "+90 (366) 214 43 63", category: "Satış Noktası" }
    ],
    "Uşak": [
      { name: "İlkimza Kuyumculuk", address: "Özdemir Mahallesi Barbaros Caddesi No:6-A, Merkez, Uşak, Türkiye", phone: "+90 (533) 487 00 64", category: "Satış Noktası" }
    ],
    "Gaziantep": [
      { name: "Storks Exclusive Gaziantep", address: "Era AVM, Osmangazi Mahallesi, Mona Roza Caddesi No: 10/F, Şehitkamil, Gaziantep, Türkiye", phone: "+90 (540) 078 67 57", category: "Mağaza" }
    ],
    "Zonguldak": [
      { name: "Moda Kuyumculuk", address: "Mithatpaşa Mahallesi Gazi Paşa Caddesi No:32-33, Merkez, Zonguldak, Türkiye", phone: "+90 (372) 253 05 44", category: "Satış Noktası" },
      { name: "Sesliler Kuyumculuk", address: "Müftü Mahallesi Uzunçarşı Sokak No:28, Ereğli, Zonguldak, Türkiye", phone: "+90 (372) 323 09 60", category: "Satış Noktası" }
    ],
    "Almanya Berlin": [
      { name: "Hatay Juwelier", address: "Kottbusser Damm 101 / 10967, Berlin, Almanya", phone: "+49 306921502", category: "Satış Noktası" }
    ],
    "Almanya Bonn": [
      { name: "Side Brillant", address: "Kölner Str 59, 53840 Troisdorf, Bonn, Almanya", phone: "+49 22411260857", category: "Satış Noktası" }
    ],
    "Almanya Hamburg": [
      { name: "Atıl Juwelier", address: "Ottonser Hauptstr.10 22765, Hamburg, Almanya", phone: "+49 4039906075", category: "Satış Noktası" }
    ],
    "Almanya Munich": [
      { name: "F&F Schmuck Collection", address: "Bayerstrasse 3 Mathaser Passage 80335, Munich, Almanya", phone: "+49 8938900926", category: "Satış Noktası" }
    ],
    "Almanya Nürnberg": [
      { name: "Savran Juwelier", address: "Nürnberger Strasse 23 91052 Erlangen, Almanya", phone: "+4991315304515", category: "Satış Noktası" }
    ],
    "Almanya Remscheid": [
      { name: "Efes Juwelier", address: "Alleestr 75 D-42853 Remscheid, Almanya", phone: "+49 2191209898", category: "Satış Noktası" }
    ],
    "Almanya Wiesbaden": [
      { name: "Juwelier Damla", address: "Wellritzstr.3 65183 Wiesbaden, Almanya", phone: "+49 1742417375", category: "Satış Noktası" }
    ],
    "Arnavutluk Tiran": [
      { name: "EM Diamonds & Jewellery", address: "Toptani Shopping Center, Tiran, Arnavutluk", phone: "", category: "Satış Noktası" }
    ],
    "Irak Bağdat": [
      { name: "Ghina Jewellery", address: "Zayoona - Al - Rubaiey Street, Violla Complex, Baghdad, Iraq", phone: "+9647711063311", category: "Satış Noktası" }
    ],
    "Bulgaristan": [
      { name: "Storks Bulgaristan", address: "Plovdiv Plaza Mall 3, Dr. Georgi Stranski Str, 1st Floor, Unit 1107, 4000 Plovdiv, Bulgaristan", phone: "+359 87 698 4584", category: "Mağaza" }
    ],
    "Kazakistan Atyrau": [
      { name: "Carat Jewellery", address: "Atyrau AVM 37, Atyrau, Kazakistan", phone: "", category: "Satış Noktası" }
    ],
    "KKTC Lefkoşa": [
      { name: "İray Kuyumculuk", address: "Küçükkaymaklı Mahallesi Gazeteci Kemal Aşık Caddesi, Lefkoşa, Kıbrıs T.C.", phone: "+90 (392) 228 86 02", category: "Satış Noktası" },
      { name: "Lal Kuyumculuk", address: "Şehit Kemal Ünal Caddesi No:127/B, Lefkoşa, Kıbrıs T.C.", phone:"", category: "Satış Noktası" }
    ],
    "Rusya Moskova": [
      { name: "Storks Rusya Ofis", address: "109147, Moscow. ext.ter.g. Tagansky municipal district, Marxistskaya str., 3 p. 3 premises.1/N, Tagansky municipal dis", phone: "+79164429970", category: "Satış Noktası" }
    ],
    "Moldova": [
      { name: "Carat Jewellery", address: "BD.Stefan Cel Mare 128/1, Chısınau, Moldova", phone: "+37368442277", category: "Satış Noktası" }
    ],
    "Kazakistan Nur Sultan": [
      { name: "Has Diamonds", address: "Abu Dhabi Plaza 2.kat & Eurasia AVM 2.kat, Nur Sultan, Kazakistan", phone: "", category: "Satış Noktası" }
    ]
  };

function initMehdiProductStoreRequests(scope) {
  if (!scope) return;

  scope.querySelectorAll('[data-mehdi-pstore]:not([data-ready])').forEach(function (root) {
    root.dataset.ready = 'true';

    const openButton = root.querySelector('[data-mehdi-pstore-open]');
    const closeButton = root.querySelector('[data-mehdi-pstore-close]');
    const overlay = root.querySelector('[data-mehdi-pstore-overlay]');
    const drawer = root.querySelector('[data-mehdi-pstore-drawer]');
    const citySelect = root.querySelector('[data-mehdi-pstore-city]');
    const results = root.querySelector('[data-mehdi-pstore-results]');
    const skuNode = root.querySelector('[data-mehdi-pstore-sku]');
    const variantNode = root.querySelector('[data-mehdi-pstore-variant]');
    const variantRow = root.querySelector('[data-mehdi-pstore-variant-row]');
    const storesScript = root.querySelector('[data-mehdi-pstore-stores]');
    const variantsScript = root.querySelector('[data-mehdi-pstore-variants]');

    if (!openButton || !closeButton || !overlay || !drawer || !citySelect || !results) return;

    let stores = [];
    let variants = [];
    let lastFocused = null;
    let closeTimer = null;

    try {
      stores = JSON.parse(storesScript ? storesScript.textContent : '[]');
      variants = JSON.parse(variantsScript ? variantsScript.textContent : '[]');
    } catch (error) {
      console.log('Mağaza verileri okunamadı:', error);
    }

    function normalizeStoreKey(value) {
      return String(value || '')
        .trim()
        .toLocaleLowerCase('tr-TR')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/ı/g, 'i')
        .replace(/ğ/g, 'g')
        .replace(/ü/g, 'u')
        .replace(/ş/g, 's')
        .replace(/ö/g, 'o')
        .replace(/ç/g, 'c')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    function getCompleteStoreList(metaobjectStores) {
      const completeStores = [];
      const storeIndexes = new Map();

      Object.keys(MEHDI_PSTORE_FALLBACK_DATA).forEach(function (city) {
        MEHDI_PSTORE_FALLBACK_DATA[city].forEach(function (store) {
          const item = Object.assign({ city: city, district: '', mapLink: '', order: 0 }, store);
          const key = normalizeStoreKey(city) + '|' + normalizeStoreKey(item.name);
          storeIndexes.set(key, completeStores.length);
          completeStores.push(item);
        });
      });

      (Array.isArray(metaobjectStores) ? metaobjectStores : []).forEach(function (store) {
        if (!store || !store.name || !store.city || !store.address) return;

        const city = String(store.city).trim();
        const key = normalizeStoreKey(city) + '|' + normalizeStoreKey(store.name);
        const existingIndex = storeIndexes.get(key);

        if (existingIndex !== undefined) {
          completeStores[existingIndex] = Object.assign({}, completeStores[existingIndex], store, { city: city });
          return;
        }

        storeIndexes.set(key, completeStores.length);
        completeStores.push(Object.assign({ district: '', mapLink: '', order: 0 }, store, { city: city }));
      });

      return completeStores;
    }

    stores = getCompleteStoreList(stores);

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>'"]/g, function (character) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          "'": '&#39;',
          '"': '&quot;'
        }[character];
      });
    }

    function phoneHref(phone) {
      return String(phone || '').split(/[&,]/)[0].replace(/[^+\d]/g, '');
    }

    function whatsappPhone(phone) {
      const value = String(phone || '').trim();
      if (!value) return '';

      const mobileMatch = value.match(/(?:\+?90|0)?\s*\(?5\d{2}\)?(?:[\s.-]*\d){7}/);
      const selectedPhone = mobileMatch
        ? mobileMatch[0]
        : value.split(/\s*(?:&|,|\/|\s+-\s+)\s*/)[0];
      let digits = selectedPhone.replace(/\D/g, '');

      if (digits.startsWith('00')) digits = digits.slice(2);
      if (digits.length === 10 && digits.startsWith('5')) digits = '90' + digits;
      if (digits.length === 10 && digits.startsWith('2')) digits = '90' + digits;
      if (digits.length === 11 && digits.startsWith('0')) digits = '90' + digits.slice(1);

      return digits;
    }

    function getSelectedVariant() {
      const productScope = root.closest('.product-details') || root.closest('[data-product-id]') || scope;
      const idInput = productScope.querySelector('form[action*="/cart/add"] input[name="id"]');
      const id = idInput ? String(idInput.value) : '';

      return variants.find(function (variant) {
        return String(variant.id) === id;
      }) || variants[0] || {};
    }

    function syncVariant() {
      const variant = getSelectedVariant();

      if (skuNode) skuNode.textContent = variant.sku || 'Belirtilmemiş';
      if (variantNode) variantNode.textContent = variant.title || '';
      if (variantRow) {
        variantRow.classList.toggle(
          'is-hidden',
          !variant.title || variant.title === 'Default Title'
        );
      }
    }

    const cities = Array.from(new Set(stores.map(function (store) {
      return String(store.city || '').trim();
    }).filter(Boolean))).sort(function (a, b) {
      return a.localeCompare(b, 'tr');
    });

    cities.forEach(function (city) {
      const option = document.createElement('option');
      option.value = city;
      option.textContent = city;
      citySelect.appendChild(option);
    });

    if (!cities.length) {
      citySelect.disabled = true;
      results.innerHTML = '<div class="mehdi-pstore__empty">Aktif mağaza kaydı bulunamadı.</div>';
    }

    function buildWhatsAppUrl(store) {
      const variant = getSelectedVariant();
      const selectedPhone = whatsappPhone(store.phone);
      if (!selectedPhone) return '';

      const lines = [
        'Merhaba, bu ürünü mağazada görmek istiyorum.',
        '',
        'Ürün: ' + root.dataset.productTitle,
        'Ürün kodu: ' + (variant.sku || 'Belirtilmemiş'),
        variant.title && variant.title !== 'Default Title' ? 'Seçenek: ' + variant.title : '',
        'Mağaza: ' + store.name,
        'İl: ' + store.city,
        'Ürün bağlantısı: ' + root.dataset.productUrl,
        '',
        'Ürün durumunu kontrol edip benimle iletişime geçebilir misiniz?'
      ].filter(function (line) {
        return line !== '';
      });

      return 'https://wa.me/' + selectedPhone + '?text=' + encodeURIComponent(lines.join('\n'));
    }

    function renderStores(city) {
      if (!city) {
        results.innerHTML = '<div class="mehdi-pstore__empty">Mağazaları görmek için önce il seçiniz.</div>';
        return;
      }

      const cityStores = stores.filter(function (store) {
        return String(store.city || '').trim() === city;
      }).sort(function (a, b) {
        const aStorePriority = normalizeStoreKey(a.category).includes('magaza') ? 0 : 1;
        const bStorePriority = normalizeStoreKey(b.category).includes('magaza') ? 0 : 1;

        if (aStorePriority !== bStorePriority) {
          return aStorePriority - bStorePriority;
        }

        return (Number(a.order) || 0) - (Number(b.order) || 0);
      });

      if (!cityStores.length) {
        results.innerHTML = '<div class="mehdi-pstore__empty">Bu il için aktif mağaza bulunamadı.</div>';
        return;
      }

      results.innerHTML = cityStores.map(function (store) {
        const phone = String(store.phone || '').trim();
        const whatsappUrl = buildWhatsAppUrl(store);
        const mapLink = String(store.mapLink || '').trim() ||
          'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(store.address || store.name);
        const address = [store.district, store.address].filter(Boolean).join(' · ');

        return `
          <article class="mehdi-pstore__card">
            <div class="mehdi-pstore__card-top">
              <h3>${escapeHtml(store.name)}</h3>
            </div>
            <p class="mehdi-pstore__address">${escapeHtml(address)}</p>
            ${phone ? `<a class="mehdi-pstore__phone" href="tel:${escapeHtml(phoneHref(phone))}">${escapeHtml(phone)}</a>` : ''}
            <div class="mehdi-pstore__actions">
              ${whatsappUrl ? `<a class="mehdi-pstore__request" href="${whatsappUrl}" target="_blank" rel="noopener">Bu Mağazadan Talep Et</a>` : ''}
              ${mapLink ? `<a class="mehdi-pstore__map" href="${escapeHtml(mapLink)}" target="_blank" rel="noopener">Yol Tarifi</a>` : ''}
            </div>
          </article>`;
      }).join('');
    }

    function openDrawer() {
      lastFocused = document.activeElement;
      syncVariant();
      window.clearTimeout(closeTimer);
      overlay.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mehdi-pstore-lock');

      window.requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        drawer.classList.add('is-open');
        closeButton.focus();
      });
    }

    function closeDrawer() {
      if (!drawer.classList.contains('is-open') && drawer.getAttribute('aria-hidden') === 'true') {
        return false;
      }

      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mehdi-pstore-lock');

      closeTimer = window.setTimeout(function () {
        overlay.hidden = true;
      }, 330);

      if (lastFocused && typeof lastFocused.focus === 'function' && lastFocused.isConnected) {
        lastFocused.focus();
      }

      return true;
    }

    root.mehdiStoreRequestClose = closeDrawer;
    openButton.addEventListener('click', openDrawer);
    closeButton.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    citySelect.addEventListener('change', function () {
      renderStores(citySelect.value);
    });

    const productDetails = root.closest('.product-details');
    if (productDetails) {
      productDetails.addEventListener('change', function () {
        window.setTimeout(syncVariant, 0);
      });
    }
  });
}

function closeActiveMehdiStoreRequest() {
  const activeDrawer = document.querySelector('[data-mehdi-pstore-drawer].is-open');
  if (!activeDrawer) return false;

  const root = activeDrawer.closest('[data-mehdi-pstore]');
  if (!root || typeof root.mehdiStoreRequestClose !== 'function') return false;

  return root.mehdiStoreRequestClose();
}

function handleMehdiQuickMediaChange(event) {
  const target = getEventElement(event);

  if (target && target.closest('#mehdiPanel #mehdiContent')) {
    pauseMehdiQuickVideos();
  }
}

function pauseMehdiQuickVideos() {
  const quickViewRoot = document.getElementById('mehdiContent');
  if (!quickViewRoot) return;

  quickViewRoot.querySelectorAll('video').forEach(function (video) {
    video.pause();
  });

  quickViewRoot.querySelectorAll('iframe[data-video-type]').forEach(function (iframe) {
    if (!iframe.contentWindow) return;

    iframe.contentWindow.postMessage(
      iframe.dataset.videoType === 'youtube'
        ? '{"event":"command","func":"pauseVideo","args":""}'
        : '{"method":"pause"}',
      '*'
    );
  });
}

function getEventElement(event) {
  if (!event || !event.target) return null;

  if (event.target instanceof Element) return event.target;

  return event.target.parentElement || null;
}

function canOpenMehdiQuick() {
  return Boolean(
    document.getElementById('mehdiContent') &&
    document.getElementById('mehdiPanel') &&
    document.getElementById('mehdiOverlay')
  );
}

function getCurrentCollectionContext() {
  try {
    const parsed = new URL(window.location.href);
    const match = parsed.pathname.match(/^(.*\/collections\/([^\/]+))(?:\/|$)/);

    if (!match) return null;

    return {
      handle: decodeURIComponent(match[2]),
      url: match[1]
    };
  } catch (e) {
    return null;
  }
}

function getFetchUrl(url) {
  try {
    return new URL(url, window.location.origin).href;
  } catch (e) {
    return url;
  }
}

function getProductHandleFromUrl(url) {
  try {
    const parsed = new URL(url, window.location.origin);
    const match = parsed.pathname.match(/\/products\/([^\/]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  } catch (e) {
    return null;
  }
}

function removeExistingRecommendations(root) {
  if (!root) return;

  const selectors = [
    '[id*="__product_recommendations"]',
    '#shopify-section-product-recommendations',
    '[data-testid="product-recommendations-section"]',
    '.mehdi-related'
  ];

  selectors.forEach(function (selector) {
    root.querySelectorAll(selector).forEach(function (el) {
      const shopifySection = el.closest('.shopify-section');

      if (shopifySection) {
        shopifySection.remove();
      } else {
        el.remove();
      }
    });
  });
}

function loadCollectionRecommendations({
  collectionHandle,
  collectionUrl,
  currentProductHandle,
  mountEl,
  renderToken
}) {
  const recommendationsUrl = collectionUrl || getLocalizedCollectionUrl(collectionHandle);

  if (!recommendationsUrl || !mountEl) return;

  fetchMehdiQuickCollectionCards(recommendationsUrl)
    .then(function (productCards) {
      if (renderToken !== mehdiQuickRenderToken) return;
      if (!mountEl.isConnected) return;

      const cards = productCards
        .filter(function (card) {
          return card.handle !== currentProductHandle;
        })
        .slice(0, 4);

      if (!cards.length) return;

      const relatedHTML = `
        <section class="mehdi-related">
          <h3 class="mehdi-related__title">
            Benzer Ürünler
          </h3>

          <div class="mehdi-related__grid mehdi-related__grid--theme-cards">
            ${cards.map(function (card) {
              return card.html;
            }).join('')}
          </div>
        </section>
      `;

      mountEl.insertAdjacentHTML('beforeend', relatedHTML);

      optimizeMehdiQuickImages(mountEl.querySelector('.mehdi-related'));
      bindInnerQuickLinks();
    })
    .catch(function (err) {
      console.log('Benzer ürünler yüklenemedi:', err);
    });
}

function fetchMehdiQuickCollectionCards(recommendationsUrl) {
  if (mehdiQuickCollectionCache.has(recommendationsUrl)) {
    const cachedCards = mehdiQuickCollectionCache.get(recommendationsUrl);

    touchMehdiQuickCache(
      mehdiQuickCollectionCache,
      recommendationsUrl,
      cachedCards,
      MEHDI_QUICK_COLLECTION_CACHE_LIMIT
    );

    return Promise.resolve(cachedCards);
  }

  if (mehdiQuickCollectionRequests.has(recommendationsUrl)) {
    return mehdiQuickCollectionRequests.get(recommendationsUrl);
  }

  const request = fetch(recommendationsUrl, {
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(function (res) {
      if (!res.ok) {
        throw new Error('Koleksiyon isteği başarısız: ' + res.status);
      }

      return res.text();
    })
    .then(function (html) {
      const temp = document.createElement('div');
      temp.innerHTML = html;

      const productCards = temp.querySelectorAll(
        '.card-product, .product-card, .grid__item, product-card'
      );

      const cards = [];

      productCards.forEach(function (card) {
        if (cards.length >= 16) return;

        const link = card.querySelector('a[href*="/products/"]');
        if (!link) return;

        const handle = getProductHandleFromUrl(link.href);
        if (!handle) return;

        cards.push({
          handle: handle,
          html: card.outerHTML
        });
      });

      touchMehdiQuickCache(
        mehdiQuickCollectionCache,
        recommendationsUrl,
        cards,
        MEHDI_QUICK_COLLECTION_CACHE_LIMIT
      );

      return cards;
    })
    .finally(function () {
      mehdiQuickCollectionRequests.delete(recommendationsUrl);
    });

  mehdiQuickCollectionRequests.set(recommendationsUrl, request);

  return request;
}

function bindInnerQuickLinks() {
  const root = document.getElementById('mehdiContent');
  if (!root) return;

  root.querySelectorAll('.mehdi-related a[href*="/products/"]')
    .forEach(function (el) {
      if (!el || !el.addEventListener) return;

      el.addEventListener('click', function (e) {
        if (window.innerWidth <= 749) return;
        if (!canOpenMehdiQuick()) return;

        e.preventDefault();
        e.stopPropagation();

        const currentCollection = getCurrentCollectionContext();

        fetchAndRenderProduct(this.href, currentCollection);
      });
    });
}

function getLocalizedCollectionUrl(collectionHandle) {
  if (!collectionHandle) return null;

  try {
    const parsed = new URL(window.location.href);
    const collectionsIndex = parsed.pathname.indexOf('/collections/');
    const localePrefix = collectionsIndex > -1 ? parsed.pathname.slice(0, collectionsIndex) : '';

    return localePrefix + '/collections/' + encodeURIComponent(collectionHandle);
  } catch (e) {
    return '/collections/' + encodeURIComponent(collectionHandle);
  }
}

/* Görünür ürünleri quick view için önceden yükle */
(function () {
  function start() {
    if (window.innerWidth <= 749 || !canOpenMehdiQuick()) return;
    if (!('IntersectionObserver' in window)) return;

    const connection = navigator.connection;
    if (connection && (
      connection.saveData ||
      /(^|-)2g$/.test(connection.effectiveType || '')
    )) return;

    const queued = new Set();
    const queue = [];
    let running = 0;

    function pump() {
      while (running < 2 && queue.length) {
        const url = queue.shift();
        running++;

        fetchMehdiQuickProductHtml(url, null)
          .catch(function () {
            // Tıklama sırasında normal yükleme yeniden denenir.
          })
          .finally(function () {
            running--;
            pump();
          });
      }
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        observer.unobserve(entry.target);

        const link = entry.target.querySelector('a[href*="/products/"]');
        if (!link || queued.size >= 12) return;

        const url = getFetchUrl(link.href);
        if (queued.has(url)) return;

        queued.add(url);
        queue.push(url);
      });

      pump();
    }, {
      rootMargin: '100px 0px'
    });

    document.querySelectorAll(
      '.card-product, .product-card, product-card'
    ).forEach(function (card) {
      if (!card.closest('#mehdiPanel')) observer.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();